import getValidScores from './getValidScores';
import renderTestScoreHistogram from './renderTestScoreHistogram';

function buildTestScoreHistogramChart($csv_chart_area, csv_download_url, papa_data) {
  const container = $csv_chart_area.get(0);
  const validScores = getValidScores(papa_data.data);

  renderTestScoreHistogram(container, validScores);
}

export default buildTestScoreHistogramChart;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/utils/buildTestScoreHistogramChart.js